import React from 'react';
import { Link } from 'react-router-dom';
import { useMedia } from 'react-use';

// Icons
import OraLOGO from '../../../assets/logo.svg';

// Components Styled
import { Container, Logo, MenuUser, ContainerMenuLogo } from './styles';

// Components
import { HamburguerMenu } from '../../navigation/HamburguerMenu';
import { TimerOverlay } from '../../overlays/TimerOverlay';

// Types
import { MainHeaderProps } from './types';

export default function MainHeader({
  userName,
  userMail,
  userRole,
}: MainHeaderProps): JSX.Element {
  const isLaptop = useMedia(
    `(max-width: 120rem)` // Equivalent to smallDesktop breakpoint
  );

  return (
    <Container>
      <ContainerMenuLogo>
        {isLaptop ? <HamburguerMenu /> : null}
        <Link to="/">
          <Logo src={OraLOGO} alt={'Rois Logo'} />
        </Link>
      </ContainerMenuLogo>
      {/* V4 D3 (2026-05-27): gap 1.6rem (antes 1rem) para dar
          respiración entre el TimerOverlay (round garnet 3.4rem) y
          el avatar (round 3.4rem). Antes los dos círculos quedaban
          visualmente pegados — anti-patrón clásico. */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.6rem' }}>
        {/* V4 P10 + D3 (2026-04-22): Timer overlay del RV — visible a la izquierda del avatar. */}
        <TimerOverlay />
        <MenuUser userName={userName} userMail={userMail} userRole={userRole} />
      </div>
    </Container>
  );
}
